import axios from 'axios';

const api = axios.create({
  baseURL: 'https://annexpilot.com/dashboard/wp-json/wp/v2', // Base URL for all endpoints
});

export default api;